import React, { ReactElement } from 'react'
import {
  SIconContainer,
  SImageTextContainer,
  SPhoto,
  SPhotoInProgress,
} from './PhotoInProgress.styled'
import { Text } from 'components/Typography'

export const PhotoInProgress = (props: {
  className?: string
  src?: string | null
  icon?: React.ReactElement
  text?: string
  isInProgress?: boolean
  fitType?: 'cover' | 'contain'
  spinner?: ReactElement
  children?: ReactElement
}) => {
  return (
    <SPhotoInProgress className={props.className} isInProgress={props.isInProgress}>
      <SPhoto placeholder={props.spinner} src={props.src} css={{ objectFit: props.fitType }} />
      <SImageTextContainer>
        <SIconContainer>{props.icon}</SIconContainer>
        {props.text && (
          <Text css={{ marginBottom: '1rem' }} color="white">
            {props.text}
          </Text>
        )}
        {props.children}
      </SImageTextContainer>
    </SPhotoInProgress>
  )
}
